export default class DeviceDetector {
    constructor() {
        this.allowTouch = false;
        this.deviceSize = '';
        this.deviceUserAgent = '';
        this.windowWidth = 0;
        this.initialize();
    }

    initialize() {
        this.detectDeviceUserAgent();
        this.eventDelegation();
        this.detectTouch();
        this.detectWindowWidth();
        this.detectDeviceSize();
    }

    eventDelegation() {
        if (this.isXsScreen() || this.isSmScreen()) {
            $("body").on('click', '#closeApp', ()=> {
                $("#app-redirect").removeClass('in');
                myApp.browserStorageService.setItem('closeApp', 'true');
            });

            if (!myApp.browserStorageService.getItem('closeApp')) {
                $("#app-redirect").addClass('in');
            }
        }
        
        $(window).on("resize", () => {
            this.detectWindowWidth();
            this.detectDeviceSize();
        });
    }

    detectTouch() {
        try {
            document.createEvent("TouchEvent");
            this.allowTouch = true;
        } catch (e) {
            this.allowTouch = false;
        }
    };

    isTouch() {
        return this.allowTouch;
    };
    
    detectWindowWidth() {
        this.windowWidth = window.innerWidth;
    };
    
    isXsScreen() {
        return this.windowWidth < 768;
    };

    isSmScreen() {
        return this.windowWidth > 767 && this.windowWidth < 991;
    };

    isMdScreen() {
        return this.windowWidth > 990 && this.windowWidth < 1199;
    };

    isLgScreen() {
        return this.windowWidth > 1198;
    };

    detectDeviceSize() {
        if (this.isXsScreen()) {
            this.deviceSize = 'xs';
        } else if (this.isSmScreen()) {
            this.deviceSize = 'sm';
        } else if (this.isMdScreen()) {
            this.deviceSize = 'md';
        } else if (this.isLgScreen()) {
            this.deviceSize = 'lg';
        }
    };

    setAttributesByDevice(devices, elements, attributes) {
        let apply;

        $.each(devices, () => {
            switch (this.deviceSize) {
                case 'xs':
                    if (this.isXsScreen() && this.isTouch()) {
                        apply = true;
                    }
                    break;
                case 'sm':
                    if (!this.isSmScreen() && this.isTouch()) {
                        apply = true;
                    }
                    break;
                case 'md':
                    if (!this.isMdScreen()) {
                        apply = true;
                    }
                    break;
                case 'lg':
                    if (!this.isLgScreen()) {
                        apply = true;
                    }
                    break;
            }
            if (apply) {
                $.each(elements, (key, element) => {
                    $.each(attributes, (attribute, value) => {
                        $(element).attr(attribute, value);
                    });
                });
            }
        });
    };

    detectDeviceUserAgent() {
        if (navigator.userAgent.match(/(iPhone)/)) {
            this.deviceUserAgent = 'iPhone';
        } else if (navigator.userAgent.match(/(iPad)/)) {
            this.deviceUserAgent = 'iPad';
        } else if (navigator.userAgent.match(/(Windows Phone)/)) {
            this.deviceUserAgent = 'Windows Phone';
        } else if (navigator.userAgent.match(/(Android)/)) {
            this.deviceUserAgent = 'Android';
        }
    }

    detectDeviceBrowser() {
        let result = '';
        if (navigator.userAgent.search("MSIE") >= 0) result = 'ie';
        else if (navigator.userAgent.search("Chrome") >= 0) result = 'chrome';
        else if (navigator.userAgent.search("Firefox") >= 0) result = 'firefox';
        else if (navigator.userAgent.search("Safari") >= 0 && navigator.userAgent.search("Chrome") < 0) result = 'safari';
        else if (navigator.userAgent.search("Opera") >= 0) result = 'opera';
        return result;
    }
}
